import type { InferOutput } from "valibot";
import { type Options, useMutation } from "../useMutation";
import { type RequestProgramAddressInputSchema, RequestProgramAddressOutputSchema } from "./schemaTypes";

export const useRequestProgramAddressMutation = (options?: Options<InferOutput<RequestProgramAddressOutputSchema>>) => {
  return useMutation<RequestProgramAddressInputSchema, RequestProgramAddressOutputSchema>(
    "/api/request-program-address/",
    RequestProgramAddressOutputSchema,
    options,
  );
};
